import React, { useEffect, useState } from 'react'
import { apiAusenciasService } from 'services/apiAusenciasService';

const ComputoAnual = (props) => {
    const [computo, setComputo] = useState({
        vacaciones: 0,
        ausecias: 0,
        bajas: 0,
        laborables: 0,
        festivos: 0,
      });

    useEffect(() => {
        const fetchData = async () =>{
            const responseComputo = await apiAusenciasService.getComputo(
                props.empleado.id,
                props.anno
            );
            
            
            setComputo(responseComputo)
        }
        
        fetchData();
    
    }, [props.empleado.id, props.anno])
    

  return (
    <>   
        <td className='text-left'>
            {props.empleado.apellidos + ", " + props.empleado.nombre}
        </td>
        <td>
            {computo.laborables * props.multiplicarHoras}
        </td>
        <td>
            {computo.vacaciones * props.multiplicarHoras}
        </td>
        <td>
            {computo.festivos * props.multiplicarHoras}
        </td>
        <td>
            {computo.ausecias  * props.multiplicarHoras}
        </td>
        <td>
            {computo.bajas * props.multiplicarHoras}
        </td>
        
    </>
  )
}

export default ComputoAnual